import { render, staticRenderFns } from "./StandNoCards.vue?vue&type=template&id=d2ec6db4&"
import script from "./StandNoCards.vue?vue&type=script&lang=js&"
export * from "./StandNoCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports